import boletinData from './boletin-data';

import blogImg1 from '../images/boletin/screens/img-1.jpg';
import blogAvaterImg2 from '../images/boletin/blog-avater/img-2.jpg';
import blogSingleImg1 from '../images/boletin/boletin1.jpg';

const images = {
  1: {
    screens: blogImg1,
    authorImg: blogAvaterImg2,
    blogSingleImg: blogSingleImg1,
  },
};

const blogs = boletinData.map((blog) => ({ ...blog, ...images[blog.id] }));

export default blogs;
